// import { Button, ButtonProps } from '@mui/material';

import { useMediaQuery, Theme, Box, Stack, Typography } from '@mui/material';
import { Button, ButtonProps } from 'react-admin';
import { Link, LinkProps } from 'react-router-dom';


export const ToolbarStyledButton = <D extends React.ElementType = 'button'>(props: ButtonProps<D>) => {
    const { children, label, ...rest } = props;
    const isXSmall = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down('sm')
    );
    return (
        <Button
            {...props}
            sx={{py:["2px","4px"], px:["6px","16px"]}}            
        >
            <Stack direction={"column"} alignItems={"center"}>
                {children}
                {isXSmall && <Typography variant='caption'>{label}</Typography>}
            </Stack>
        </Button>
    )
}

interface Props extends Pick<LinkProps, 'to'> {
    label: string,
    // record: Record
}

export const ToolbarLinkButton = <D extends React.ElementType = 'button'>(props: ButtonProps<D> & Props) => {

    return (
        <ToolbarStyledButton
            component={Link}
            {...props}
        />
    )
}